import React, {useState} from "react";
import {Order} from "../shared/tables/_interfaces";
import moment from "moment/moment";
import {TestType} from "../shared/types/testTypes";

const useDataTable = (tableType: string, defaultOrderBy: string, type?: TestType | undefined, pageType?: string | undefined,) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [tableColumns, setTableColumns] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [perPage, setPerPage] = useState<number>(15);
    const [page, setPage] = useState<number>(0);
    const [order, setOrder] = useState<Order>("desc");
    const [orderBy, setOrderBy] = useState<string>(defaultOrderBy);
    const [query, setQuery] = useState<string>("");
    const [submittedQuery, setSubmittedQuery] = useState<string>("");
    const [testType, setTestType] = useState<TestType>(type ? type : "school");
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const [startDate, setStartDate] = useState<any>("");
    const [endDate, setEndDate] = useState<any>("");

    const [filterValues, setFilterValues] = useState<Record<string, any>>(tableType === "testsHistory" && (pageType === "classroom" || pageType === "student") ? {type: "school"} : {});
    const [activeColumnIds, setActiveColumnIds] = useState<string[]>(tableType === "testsHistory" && (pageType === "classroom" || pageType === "student") ? ["type"] : []);
    const [currentFilters, setCurrentFilters] = useState<Record<string, any>>(tableType === "testsHistory" && (pageType === "classroom" || pageType === "student") ? {type: "school"} : {});

    const handleChangePage = (_event: unknown, newPage: number) => {
        setTableData([]);
        setPage(newPage);
    };

    const setSelectedHandler = (newSelected: number[]) => {
        setSelectedRows(newSelected);
    }

    const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        setPage(0);
    };

    const handleSearch = (data: string) => {
        setPage(0);
        setSubmittedQuery(data);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setQuery(event.target.value);
    }

    const handleClearSearch = () => {
        setPage(0);
        setQuery("");
        setSubmittedQuery("");
    };

    const handleFilterChange = (filterType: string, columnId: string, value: any) => {
        if(columnId === "type" && tableType === "testsHistory") {
            setTestType(value);
            setFilterValues({type: value});
            setActiveColumnIds(["type"]);
            setStartDate("");
            setEndDate("");
        } else {
            if(filterType === "dateRange" || filterType === "schoolYear") {
                const [start, end] = value;
                setStartDate(start ? moment(start).locale("ro").format("YYYY-MM-DD") : "");
                setEndDate(end ? moment(end).locale("ro").format("YYYY-MM-DD") : "");
                setFilterValues(prev => ({
                    ...prev,
                    [columnId]: value,
                }))

            } else {
                setFilterValues(prev => ({
                    ...prev,
                    [columnId]: value,
                }));
            }
        }
        setPage(0);
    };

    const handleResetFilters = () => {
        if(tableType === "testsHistory" && (pageType === "classroom" || pageType === "student")) {
            setTestType("school");
            setFilterValues({type: "school"});
            setCurrentFilters({type: "school"});
            setActiveColumnIds(["type"]);
        } else {
            setFilterValues({});
            setCurrentFilters({});
            setActiveColumnIds([]);
        }

        setStartDate("");
        setEndDate("");
        setPage(0)
    };

    const handleApplyFilters = () => {
        setCurrentFilters(filterValues);
    };

    const handleCancelFilters = () => {
        // optional: close popover / modal, but DON'T clear state here unless you want both forms to reset
    };

    return {
        loading,
        setLoading,
        tableData,
        setTableData,
        tableColumns,
        setTableColumns,
        totalRows,
        setTotalRows,
        perPage,
        setPerPage,
        page,
        setPage,
        query,
        submittedQuery,
        setSubmittedQuery,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        selectedRows,
        setSelectedHandler,
        startDate,
        endDate,
        filterValues,
        setFilterValues,
        activeColumnIds,
        setActiveColumnIds,
        currentFilters,
        setCurrentFilters,
        testType,
        handleSearch,
        handleResetFilters,
        handleApplyFilters,
        handleCancelFilters,
        handleChangePage,
        handleRequestSort,
        handleClearSearch,
        handleFilterChange,
        handleSearchChange,
    }
};

export default useDataTable;